export default "__VITE_ASSET__2KDC0Wwz__"